namespace Portico.Models.Enterprise {

    import ent = Portico.Models.Enterprise;

    export interface IEnrollmentEligibility {
        status: string;
		conditions: EnrollmentCondition[];
    }

    export class EnrollmentEligibility implements IEnrollmentEligibility {
		status: string;
		conditions: EnrollmentCondition[];

        constructor(obj?: IEnrollmentEligibility) {
			this.status = null;
			this.conditions = [];

            if (obj) {
				this.status = obj.status;

				if (obj.conditions) {
					for (const condition of obj.conditions) {
						this.conditions.push(new ent.EnrollmentCondition(condition));
                    }
                }
            }
        }
    }
}

